import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectEvents = (state: any): any => state.events;
const selectEventId = (_state: any, props: any): any =>
    props.eventId && `${props.eventId}`;

const selectAllEvents = createDeepEqualSelector(
    [selectEvents],
    (eventsState) => eventsState
);

const selectEventsArray = createDeepEqualSelector(
    selectAllEvents,
    (allEventsState) => Object.values(allEventsState)
);

const selectEvent = createDeepEqualSelector(
    selectAllEvents,
    selectEventId,
    (allEventsState, eventId) => eventId && allEventsState[eventId]
);

const makeSelectEventValue = (field: string): any =>
    createDeepEqualSelector(
        selectEvent,
        (eventState) => eventState && eventState[field]
    );

export { selectEvents, selectEventsArray, selectEvent, makeSelectEventValue };
